import { createFileRoute } from '@tanstack/react-router';
import { UsageTopic } from '../screens/company/topics/UsageTopic';

export const Route = createFileRoute('/t/$tenant/settings/billing/usage')({
  component: UsageTopic,
});
